import { parsePhoneNumberFromString } from 'libphonenumber-js/core';
export default function isPossiblePhoneNumber(value, metadata) {
  if (!value) {
    return false;
  }

  var phoneNumber = parsePhoneNumberFromString(value, metadata);

  if (!phoneNumber) {
    return false;
  }

  return phoneNumber.isPossible();
}
//# sourceMappingURL=isPossiblePhoneNumber.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/react-phone-number-input/modules/libphonenumber/isPossiblePhoneNumber.js
// module id = 1722
// module chunks = 6 14 79